import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { Collapse, message } from "antd";

import {
  req_single_ams_alumni,
  req_edit_ams_alumni,
  req_edit_gqm_alumniApplyModify,
} from "../../api";

const { Panel } = Collapse;
class AlumniApplyModifyCheckModal extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  static propTypes = {
    sourcealumni: PropTypes.object.isRequired,
  };

  state = {
    deviceWidth: 0,
    originalalumni: {},
    targetalumni: {
      TwId: this.props.sourcealumni.TwId,
      TelephoneSurveyOperator: this.props.user.userCode,
      NowStatusModifyOperator: this.props.sourcealumni.TwId,
      NowStatusSource: "自行異動",
      ProcessStatus: "",
      AlumniName: "",
      NowStatusPrimary: "",
      NowStatusSecondary: "",
      NowStatusPrimarySecondary: "",
      MobilePrincipal: "",
      MobileSpare: "",
      TelephonePrincipal: "",
      TelephoneSpare: "",
      EmailPrincipal: "",
      EmailSpare: "",
      MailingAddress: "",
      ResidentAddress: "",
      LastFinalDegree: "",
      LastFinalUniversity: "",
      LastFinalDepartmentName: "",
      LastFinalMajor: "",
      ContinueLearnLocation: "",
      ContinueLearnUniversity: "",
      ContinueLearnDepartmentName: "",
      ContinueLearnDegree: "",
      ContinueLearnDivision: "",
      JobType: "",
      JobCompany: "",
      JobDepartment: "",
      JobTitle: "",
      JobTelephone: "",
      JobAddress: "",
      JobFax: "",
      JobFirstSalary: "0",
      CurrentSalary: "0",
      JobBossName: "",
      JobBossEmail: "",
      condition: "",
    },
  };

  componentDidMount() {
    this.api_single_item();
  }

  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_single_item = async () => {
    const { token } = this.props.user;
    const { TwId } = this.props.sourcealumni;

    this.setState({ loading: true });
    const result = await req_single_ams_alumni(TwId, token);
    this.setState({ loading: false });
    const originalalumni = result;
    this.setState({ originalalumni });
  };

  api_edit_item = async (item) => {
    const { token } = this.props.user;
    const result = await req_edit_ams_alumni(item, token);
    if (result.status === "success") {
      // console.log(result)
      message.success(result.message);
      //this.api_single_item()
    } else {
      message.error(result.message);
    }
  };

  api_edit_item_status = async (item) => {
    const { token } = this.props.user;
    const result = await req_edit_gqm_alumniApplyModify(item, token);
    if (result.status === "success") {
      // console.log(result)
      message.success(result.message);
      //this.api_single_item()
    } else {
      message.error(result.message);
    }
  };

  ///////////////////////////////////////////////////////////
  handleSubmit(event) {
    event.preventDefault();
  }

  handleChange(event) {
    const { targetalumni } = this.state;
    //console.log(event)
    Object.keys(targetalumni).forEach((propertyName) => {
      if (event.target.id === propertyName && event.target.value !== null) {
        targetalumni[propertyName] = event.target.value.trim();
      }
    });
    this.setState({ targetalumni });
  }

  handle_ui_click = (field) => {
    const { originalalumni, targetalumni } = this.state;
    switch (field) {
      case "NowStatusSecondary":
        const { NowStatusPrimary, NowStatusSecondary } =
          this.props.sourcealumni;
        originalalumni["NowStatusSecondary"] = NowStatusSecondary;
        targetalumni["NowStatusSecondary"] = NowStatusSecondary;
        originalalumni["NowStatusPrimary"] = NowStatusPrimary;
        targetalumni["NowStatusPrimary"] = NowStatusPrimary;
        targetalumni["condition"] = "SELFSTATUS";
        //NowStatusModifyDateTime
        this.setState({ originalalumni, targetalumni }, () => {
          //console.log(targetalumni);
          this.api_edit_item(targetalumni);
        });
        break;
      case "AlumniName":
        const { AlumniName } = this.props.sourcealumni;
        originalalumni["AlumniName"] = AlumniName.trim();
        targetalumni["AlumniName"] = AlumniName.trim();
        targetalumni["condition"] = "SELFNAME";
        //NowStatusModifyDateTime
        this.setState({ originalalumni, targetalumni }, () => {
          //console.log(targetalumni);
          this.api_edit_item(targetalumni);
        });
        break;
      case "MobilePrincipal":
        const { MobilePrincipal } = this.props.sourcealumni;
        originalalumni["MobilePrincipal"] = MobilePrincipal.trim();
        targetalumni["MobilePrincipal"] = MobilePrincipal.trim();
        targetalumni["condition"] = "SELFMOBILE";
        //NowStatusModifyDateTime
        this.setState({ originalalumni, targetalumni }, () => {
          //console.log(targetalumni);
          this.api_edit_item(targetalumni);
        });
        break;
      case "TelephonePrincipal":
        const { TelephonePrincipal } = this.props.sourcealumni;
        originalalumni["TelephonePrincipal"] = TelephonePrincipal.trim();
        targetalumni["TelephonePrincipal"] = TelephonePrincipal.trim();
        targetalumni["condition"] = "SELFTEL";
        //NowStatusModifyDateTime
        this.setState({ originalalumni, targetalumni }, () => {
          //console.log(targetalumni);
          this.api_edit_item(targetalumni);
        });
        break;
      case "EmailPrincipal":
        const { EmailPrincipal } = this.props.sourcealumni;
        originalalumni["EmailPrincipal"] = EmailPrincipal.trim();
        targetalumni["EmailPrincipal"] = EmailPrincipal.trim();
        targetalumni["condition"] = "SELFEMAIL";
        //NowStatusModifyDateTime
        this.setState({ originalalumni, targetalumni }, () => {
          //console.log(targetalumni);
          this.api_edit_item(targetalumni);
        });
        break;
      case "ResidentAddress":
        const { ResidentAddress } = this.props.sourcealumni;
        originalalumni["ResidentAddress"] = ResidentAddress.trim();
        targetalumni["ResidentAddress"] = ResidentAddress.trim();
        targetalumni["condition"] = "SELFADDRESSR";
        //NowStatusModifyDateTime
        this.setState({ originalalumni, targetalumni }, () => {
          //console.log(targetalumni);
          this.api_edit_item(targetalumni);
        });
        break;
      case "MailingAddress":
        const { MailingAddress } = this.props.sourcealumni;
        originalalumni["MailingAddress"] = MailingAddress.trim();
        targetalumni["MailingAddress"] = MailingAddress.trim();
        targetalumni["condition"] = "SELFADDRESSC";
        //NowStatusModifyDateTime
        this.setState({ originalalumni, targetalumni }, () => {
          //console.log(targetalumni);
          this.api_edit_item(targetalumni);
        });
        break;
      case "JobBossEmail":
        const {
          JobType,
          JobCompany,
          JobDepartment,
          JobTitle,
          JobTelephone,
          JobAddress,
          JobFax,
          CurrentSalary,
          JobBossName,
          JobBossEmail,
        } = this.props.sourcealumni;
        originalalumni["JobType"] = JobType;
        targetalumni["JobType"] = JobType;

        originalalumni["JobCompany"] = JobCompany;
        targetalumni["JobCompany"] = JobCompany;

        originalalumni["JobDepartment"] = JobDepartment;
        targetalumni["JobDepartment"] = JobDepartment;

        originalalumni["JobTitle"] = JobTitle;
        targetalumni["JobTitle"] = JobTitle;

        originalalumni["JobTelephone"] = JobTelephone;
        targetalumni["JobTelephone"] = JobTelephone;

        originalalumni["JobAddress"] = JobAddress;
        targetalumni["JobAddress"] = JobAddress;

        originalalumni["JobFax"] = JobFax;
        targetalumni["JobFax"] = JobFax;

        originalalumni["CurrentSalary"] = CurrentSalary;
        targetalumni["CurrentSalary"] = CurrentSalary;

        originalalumni["JobBossName"] = JobBossName;
        targetalumni["JobBossName"] = JobBossName;

        originalalumni["JobBossEmail"] = JobBossEmail;
        targetalumni["JobBossEmail"] = JobBossEmail;

        targetalumni["condition"] = "SELFJOB";
        //NowStatusModifyDateTime
        this.setState({ originalalumni, targetalumni }, () => {
          //console.log(targetalumni);
          this.api_edit_item(targetalumni);
        });
        break;
      case "LastFinalDepartmentName":
        const {
          LastFinalDegree,
          LastFinalUniversity,
          LastFinalDepartmentName,
        } = this.props.sourcealumni;
        originalalumni["LastFinalDegree"] = LastFinalDegree;
        targetalumni["LastFinalDegree"] = LastFinalDegree;
        originalalumni["LastFinalUniversity"] = LastFinalUniversity;
        targetalumni["LastFinalUniversity"] = LastFinalUniversity;
        originalalumni["LastFinalDepartmentName"] = LastFinalDepartmentName;
        targetalumni["LastFinalDepartmentName"] = LastFinalDepartmentName;
        targetalumni["condition"] = "SELFLASTEDU";
        //NowStatusModifyDateTime
        this.setState({ originalalumni, targetalumni }, () => {
          //console.log(targetalumni);
          this.api_edit_item(targetalumni);
        });
        break;
      case "ContinueLearnDepartmentName":
        const {
          ContinueLearnDegree,
          ContinueLearnUniversity,
          ContinueLearnDepartmentName,
        } = this.props.sourcealumni;
        originalalumni["ContinueLearnDegree"] = ContinueLearnDegree;
        targetalumni["ContinueLearnDegree"] = ContinueLearnDegree;
        originalalumni["ContinueLearnUniversity"] = ContinueLearnUniversity;
        targetalumni["ContinueLearnUniversity"] = ContinueLearnUniversity;
        originalalumni["ContinueLearnDepartmentName"] =
          ContinueLearnDepartmentName;
        targetalumni["ContinueLearnDepartmentName"] =
          ContinueLearnDepartmentName;
        targetalumni["condition"] = "SELFLEARN";
        //NowStatusModifyDateTime
        this.setState({ originalalumni, targetalumni }, () => {
          //console.log(targetalumni);
          this.api_edit_item(targetalumni);
        });
        break;
      default:
        break;
    }
  };

  handle_ui_tab = (key) => {
    //console.log(key);
  };

  handle_close_case = (data) => {
    const { userCode } = this.props.user;
    const { Uid } = data;
    console.log(Uid);
    const item = {
      Uid: Uid,
      ProcessStatus: "DONE",
      RecordProcessUserId: userCode,
      condition: "BASE",
    };
    this.api_edit_item_status(item);
  };

  /////////////////////////////
  render() {
    //console.log("originalalumni：", this.state.originalalumni);
    //console.log("sourcealumni", this.props.sourcealumni);
    return (
      <div>
        <form onSubmit={this.handleSubmit}>
          <div className="form-row">
            <div className="input-group mb-3">
              <div className="input-group-prepend">
                <label
                  className="input-group-text"
                  style={{ backgroundColor: "PaleGoldenRod" }}
                >
                  數據來源
                </label>
              </div>
              <input
                type="text"
                className="form-control"
                placeholder="新資料(空)"
                defaultValue={this.props.sourcealumni.NowStatusSource}
                disabled={true}
              />
              <input
                type="text"
                className="form-control"
                placeholder="舊資料(空)"
                defaultValue={this.state.originalalumni.NowStatusSource}
                disabled={true}
              />
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-4">
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <label
                    className="input-group-text"
                    style={{ backgroundColor: "PaleGoldenRod" }}
                  >
                    身份證字號
                  </label>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="新資料(空)"
                  defaultValue={this.props.sourcealumni.TwId}
                  disabled={true}
                />
              </div>
            </div>
            <div className="col-lg-8">
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <label
                    className="input-group-text"
                    style={{ backgroundColor: "PaleGoldenRod" }}
                  >
                    姓名
                  </label>
                </div>
                <div className="input-group-prepend">
                  <label className="input-group-text">由</label>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="舊資料(空)"
                  defaultValue={this.state.originalalumni.AlumniName}
                  //onChange={this.handleChange}
                  readOnly={true}
                  style={{ backgroundColor: "LightCyan" }}
                />
                <div className="input-group-prepend">
                  <label className="input-group-text">替換成</label>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="新資料(空)"
                  defaultValue={this.props.sourcealumni.AlumniName}
                  disabled={true}
                  style={{ backgroundColor: "Linen" }}
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => this.handle_ui_click("AlumniName")}
                    disabled={
                      this.props.sourcealumni.AlumniName === "" ? true : false
                    }
                  >
                    <i className="fa fa-check-square"></i> 確定
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="col-lg-6">
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <label
                    className="input-group-text"
                    style={{ backgroundColor: "PaleGoldenRod" }}
                  >
                    目前狀況
                  </label>
                </div>
                <div className="input-group-prepend">
                  <label className="input-group-text">由</label>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="舊資料(空)"
                  defaultValue={this.state.originalalumni.NowStatusPrimary}
                  readOnly={true}
                  style={{ backgroundColor: "LightCyan" }}
                />
                <div className="input-group-prepend">
                  <label className="input-group-text">替換成</label>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="新資料(空)"
                  defaultValue={this.props.sourcealumni.NowStatusPrimary}
                  disabled={true}
                  style={{ backgroundColor: "Linen" }}
                />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="input-group mb-3">
                <div className="input-group-prepend">
                  <label
                    className="input-group-text"
                    style={{ backgroundColor: "PaleGoldenRod" }}
                  >
                    狀況說明
                  </label>
                </div>
                <div className="input-group-prepend">
                  <label className="input-group-text">由</label>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="舊資料(空)"
                  defaultValue={this.state.originalalumni.NowStatusSecondary}
                  readOnly={true}
                  style={{ backgroundColor: "LightCyan" }}
                />
                <div className="input-group-prepend">
                  <label className="input-group-text">替換成</label>
                </div>
                <input
                  type="text"
                  className="form-control"
                  placeholder="新資料(空)"
                  defaultValue={this.props.sourcealumni.NowStatusSecondary}
                  disabled={true}
                  style={{ backgroundColor: "Linen" }}
                />
                <div className="input-group-append">
                  <button
                    className="btn btn-outline-secondary"
                    type="button"
                    onClick={() => this.handle_ui_click("NowStatusSecondary")}
                  >
                    <i className="fa fa-check-square"></i> 確定
                  </button>
                </div>
              </div>
            </div>
          </div>
          <Collapse defaultActiveKey={["1"]} onChange={this.handle_ui_tab}>
            <Panel header="聯絡方式" key="1">
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      行動電話
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.MobilePrincipal}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.MobilePrincipal}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={() => this.handle_ui_click("MobilePrincipal")}
                      disabled={
                        this.props.sourcealumni.MobilePrincipal === ""
                          ? true
                          : false
                      }
                    >
                      <i className="fa fa-check-square"></i> 確定
                    </button>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      市內電話
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.TelephonePrincipal}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.TelephonePrincipal}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />

                  <div className="input-group-append">
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={() => this.handle_ui_click("TelephonePrincipal")}
                      disabled={
                        this.props.sourcealumni.TelephonePrincipal === ""
                          ? true
                          : false
                      }
                    >
                      <i className="fa fa-check-square"></i> 確定
                    </button>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      電子郵件
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.EmailPrincipal}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.EmailPrincipal}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={() => this.handle_ui_click("EmailPrincipal")}
                      disabled={
                        this.props.sourcealumni.EmailPrincipal === ""
                          ? true
                          : false
                      }
                    >
                      <i className="fa fa-check-square"></i> 確定
                    </button>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      戶籍地址
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.ResidentAddress}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.ResidentAddress}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={() => this.handle_ui_click("ResidentAddress")}
                      disabled={
                        this.props.sourcealumni.ResidentAddress === ""
                          ? true
                          : false
                      }
                    >
                      <i className="fa fa-check-square"></i> 確定
                    </button>
                  </div>
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      通訊地址
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.MailingAddress}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.MailingAddress}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                  <div className="input-group-append">
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={() => this.handle_ui_click("MailingAddress")}
                      disabled={
                        this.props.sourcealumni.MailingAddress === ""
                          ? true
                          : false
                      }
                    >
                      <i className="fa fa-check-square"></i> 確定
                    </button>
                  </div>
                </div>
              </div>
            </Panel>
            <Panel header="工作內容" key="2">
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      工作型態
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.JobType}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.JobType}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      公司名稱
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.JobCompany}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.JobCompany}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      部門名稱
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.JobDepartment}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.JobDepartment}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      職位頭銜
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.JobTitle}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.JobTitle}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      公司電話
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.JobTelephone}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.JobTelephone}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      公司地址
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.JobAddress}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.JobAddress}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      公司傳真
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.JobFax}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.JobFax}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      現在薪水
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.CurrentSalary}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.CurrentSalary}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      老闆姓名
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.JobBossName}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.JobBossName}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      老闆電郵
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.JobBossEmail}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.JobBossEmail}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />

                  <div className="input-group-append">
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={() => this.handle_ui_click("JobBossEmail")}
                    >
                      <i className="fa fa-check-square"></i> 確定
                    </button>
                  </div>
                </div>
              </div>
            </Panel>
            <Panel header="最高學歷" key="3">
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      最高學位
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.LastFinalDegree}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.LastFinalDegree}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      學校名稱
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.LastFinalUniversity}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.LastFinalUniversity}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      科系名稱
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={
                      this.state.originalalumni.LastFinalDepartmentName
                    }
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={
                      this.props.sourcealumni.LastFinalDepartmentName
                    }
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />

                  <div className="input-group-append">
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={() =>
                        this.handle_ui_click("LastFinalDepartmentName")
                      }
                    >
                      <i className="fa fa-check-square"></i> 確定
                    </button>
                  </div>
                </div>
              </div>
            </Panel>
            <Panel header="學習進修" key="4">
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      進修學位
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={this.state.originalalumni.ContinueLearnDegree}
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={this.props.sourcealumni.ContinueLearnDegree}
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      進修學校
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={
                      this.state.originalalumni.ContinueLearnUniversity
                    }
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={
                      this.props.sourcealumni.ContinueLearnUniversity
                    }
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />
                </div>
              </div>
              <div className="form-row">
                <div className="input-group mb-3">
                  <div className="input-group-prepend">
                    <label
                      className="input-group-text"
                      style={{ backgroundColor: "PaleGoldenRod" }}
                    >
                      科系名稱
                    </label>
                  </div>
                  <div className="input-group-prepend">
                    <label className="input-group-text">由</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="舊資料(空)"
                    defaultValue={
                      this.state.originalalumni.ContinueLearnDepartmentName
                    }
                    readOnly={true}
                    style={{ backgroundColor: "LightCyan" }}
                  />
                  <div className="input-group-prepend">
                    <label className="input-group-text">替換成</label>
                  </div>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="新資料(空)"
                    defaultValue={
                      this.props.sourcealumni.ContinueLearnDepartmentName
                    }
                    disabled={true}
                    style={{ backgroundColor: "Linen" }}
                  />

                  <div className="input-group-append">
                    <button
                      className="btn btn-outline-secondary"
                      type="button"
                      onClick={() =>
                        this.handle_ui_click("ContinueLearnDepartmentName")
                      }
                    >
                      <i className="fa fa-check-square"></i> 確定
                    </button>
                  </div>
                </div>
              </div>
            </Panel>
          </Collapse>
          <button
            className="btn btn-danger btn-block"
            onClick={() => this.handle_close_case(this.props.sourcealumni)}
            disabled={
              this.props.sourcealumni.ProcessStatus === "DONE" ? true : false
            }
          >
            <i className="fa fa-low-vision"></i> 解管
          </button>
        </form>
      </div>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(AlumniApplyModifyCheckModal);
